import { CARD_LOGS_UPDATE_FAILURE, CARD_LOGS_UPDATE_REQUEST, CARD_LOGS_UPDATE_SUCCESS } from './constant';

export const cardLogsUpdateSuccess = () => ({ type: CARD_LOGS_UPDATE_SUCCESS });
export const cardLogsUpdateFailure = (payload) => ({ type: CARD_LOGS_UPDATE_FAILURE, payload });
export const cardLogsUpdateRequest = (id, guardAction, lotNumber) => ({ type: CARD_LOGS_UPDATE_REQUEST, payload: { id, guardAction, lotNumber } });
